import "./AboutDiscoveryConsultation.module.css";
import Header from "@/reusable_sections/Header";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function AboutDiscoveryConsultationPage() {
  return <div>
      <Header />
      <Consultation />
      <Footer />
    </div>;
}